import { render } from "./QuotationDetails.vue?vue&type=template&id=f149e8f8&scoped=true"
import script from "./QuotationDetails.vue?vue&type=script&lang=js"
export * from "./QuotationDetails.vue?vue&type=script&lang=js"

import "./QuotationDetails.vue?vue&type=style&index=0&id=f149e8f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f149e8f8"]])

export default __exports__